import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import styles from './SignupLogin.module.css';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore'


export default function Edit() {

    const location = useLocation()
    const { name, size, segment ,feature,desc,id} = location.state || {}

    const [data,setData] = useState({productName : name || "ProductName",size : size || [],segment : segment || "" ,feature : feature || [] ,desc : desc || ""})

    const [newSize,setNewSize] = useState(size || [])
    const [newCapacity,setNewCapacity] = useState("")
    const [newPrice,setNewPrice] = useState(0)

    const deleteSize = (index)=>{
        const updatedSize = newSize.filter((_, i) => i !== index);
        setNewSize(updatedSize);
    }

    const addSize = ()=>{
        const newEntry = {"capacity":newCapacity, "price" : newPrice}
        setNewSize((prev)=>{
            return [
                ...prev,
                newEntry
            ]
        })
        setNewCapacity("");
        setNewPrice(0)
    }

    const handleOnChange = (name, value) => {
        setData((prev) => {
            return {
                ...prev,
                [name]: value
            }
        })
    }

    const editData = async() => {
            // console.log("UIDSSS",userdata.uid)
            console.log("On chnage Data :",data)
            if(id)
            {
                firebase.firestore().collection(segment).doc(id).update({ ...data, size: newSize }).then(() => {
                  console.log("Document successfully updated!");
                  alert("Document successfully updated!")
                })
                .catch((error) => {
                  console.error("Error updating document: ", error);
                });
            }
        }


    return (
        <>
            <div className={styles.wrapper}>
                <div className={styles.titleText}>
                    <div className={styles.title}>Edit</div>
                </div>
                <div className={styles.SignupLogin}>


                    <div className={styles.formInner}>
                        <form className={styles.active}>
                            <label>Product Name : </label>
                            <div className={styles.field}>
                                <input type="text" value={data?.productName || "Product Name"} name='productName'
                                    onChange={({ target }) => {
                                        handleOnChange(target.name, target.value)
                                    }} 
                                     />
                            </div>
                            <label>Segment :</label>
                            <div className={styles.field}>
                                <input disabled type="text" name="segment" value={data?.segment || ""} 
                                onChange={({ target }) => {
                                        handleOnChange(target.name, target.value)
                                    }} 
                                />
                            </div>
                            <div className={styles.field} style={{width : "100%"}}>
                                <label>Description</label>
                                <textarea name='desc' rows={5} value={data?.desc || "Description"} onChange={({target})=>{handleOnChange(target.name,target.value)}}/>
                            </div>
                            <div>
                                <table style={{width : '100%',fontSize : 'medium',textAlign :'center',color : '#032C53'}}>
                                    <th>Capacity</th>
                                    <th>Price(INR)</th>
                                    <th>Delete</th>
                                    {newSize.map((sizeItem,index)=>(
                                        <tr key={index}>
                                            <td>{sizeItem.capacity}</td>
                                            <td>{sizeItem.price}</td>
                                            <td><i onClick={()=>{deleteSize(index)}} className="fa-solid fa-trash" style={{color : '#cd1313'}}></i></td>
                                        </tr>
                                    ))}
                                </table>
                                <label style={{textAlign : 'center',width : '100%',color : '#032C53',fontSize : 'larger'}}>Add New</label>

                                <div style={{width : '100%',display : 'flex',justifyContent : 'space-between'}}>
                                    <div className={styles.field} style={{width : '50%'}}>
                                        <input type='text' name={'capacity'} placeholder='Capacity' value={newCapacity} onChange={({target : {value}})=>{setNewCapacity(value)}} />
                                    </div>
                                    <div className={styles.field}>
                                        <input type='number' value={newPrice} name='price' placeholder='price(INR)' onChange={({target : {value}})=>{setNewPrice(value)}} />
                                    </div>
                                </div>
                                <div>
                                    {/* Add button */}
                                    <i class="fa-solid fa-plus fa-xl" style={{color : '#032C53'}}onClick={addSize}></i>
                                </div>
                             
                            </div>



                            <div className={styles.passLink}>
                                {/* {price} */}
                            </div>
                            <div className={`${styles.field} ${styles.btn}`}>
                                <input type="button" value="Edit" onClick={editData} />
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}
